<div class="bg-loading">
  <div class="bg-content">
    <!-- <h6 class="wave-text" style="opacity: 0">
      <span>C</span>
      <span>a</span>
      <span>r</span>
      <span>g</span>
      <span>a</span>
      <span>n</span>
      <span>d</span>
      <span>o</span>
      <span>&nbsp;</span>
      <span>u</span>
      <span>n</span>
      <span>i</span>
      <span>d</span>
      <span>a</span>
      <span>d</span>
      <span>e</span>
      <span>s</span>
    </h6> -->
    <!-- <div class="image-container">
      <img
        class="image"
        src="https://i.imgur.com/TatNo0i.gif"
        alt="car loading"
        width="150"
        height="85"
      />
    </div> -->
  </div>
</div>
